(function ($) {
    var dropDown = $(".dropdown-head");
    var dropDownBody = $(".dropdown-body");
    dropDown.on("click", function (){
        if ($(this).hasClass("active")) {
            dropDown.removeClass("active");
            dropDownBody.slideUp(300);
        } else {
            dropDown.removeClass("active");
            dropDownBody.slideUp(300);
            $(this).addClass("active");
            $(this).siblings(".dropdown-body").slideDown(300);
        }
    });
})(jQuery);



// WEBPACK FOOTER //
// ./src/js/custom/section-review_2022.es6